import React from 'react';

const MoneyIcon = ({ id, className, color, styles = {} }) => {
	const colorMap = {
		cdgr: '#5B5855',
		cgrn: '#0C4A34',
		cw: '#FFFFFF',
		cbb: '#3477AC',
	};

	return (
		<div id={id} className={className} style={styles}>
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<circle
					cx='12'
					cy='12'
					r='8'
					stroke='#B0ACA3'
					strokeWidth='2'
				/>
				<path
					d='M14.56 13.975C14.56 12.4255 13.8991 11.638 12.4625 11.2316L12.2231 11.1554V8.61512C12.6219 8.71428 12.9274 8.95858 13.1555 9.33755C13.3526 9.6649 13.7857 9.82206 14.0933 9.59542C14.281 9.45712 14.3647 9.21323 14.2743 8.99827C13.8733 8.04388 13.1624 7.49772 12.2231 7.3958V6.53689C12.2231 6.37292 12.0902 6.23999 11.9262 6.23999C11.7622 6.23999 11.6293 6.37292 11.6293 6.53689V7.3958C10.3172 7.51011 9.46477 8.4246 9.46477 9.77093C9.46477 11.1173 10.0682 11.9301 11.3707 12.3112L11.6293 12.3874V15.3468C11.119 15.2528 10.7084 14.9432 10.4052 14.3769C10.2261 14.0423 9.80948 13.8746 9.48499 14.0713C9.26783 14.2029 9.15702 14.4624 9.24314 14.7013C9.6557 15.8456 10.5112 16.5002 11.6293 16.5915V17.4631C11.6293 17.6271 11.7622 17.76 11.9262 17.76C12.0902 17.76 12.2231 17.6271 12.2231 17.4631V16.5915C13.6597 16.4645 14.56 15.4484 14.56 13.975ZM10.5853 9.73282C10.5853 9.02156 10.9876 8.62782 11.6293 8.57701V10.9775C10.8631 10.7108 10.5853 10.3679 10.5853 9.73282ZM12.2231 15.3722V12.5652C13.0851 12.8573 13.4203 13.2257 13.4203 14.0258C13.4203 14.8133 12.9701 15.296 12.2231 15.3722Z'
					fill={`${colorMap[color] || '#B0ACA3'}`}
				/>
			</svg>
		</div>
	);
};

export default MoneyIcon;
